import qs from "qs";
import FycLinkCTAButtonProps from "./SanityFycLinkCTA";
import { isPresent } from "src/utils/checks";
import { AlgoliaURLFacets } from "types/algolia";
import { Language } from "src/utils/localization/languages/types";
import { buildDepartureYearsMonths } from "./utils";

type Props = Omit<FycLinkCTAButtonProps, "variant" | "label">;

export const buildFycLinkCTAUrl = (props: Props, language: Language) => {
  const refinementList: Partial<Record<keyof AlgoliaURLFacets, string[]>> = {
    destinationNames:
      props.filterByDestination
        ?.map((d) => d?.name?.localized)
        .filter(isPresent) || [],
    promoCodes:
      props.filterByOffer
        ?.map((o) => o?.configuration?.code)
        .filter(isPresent) || [],
    dayGroup: props.filterByDurations?.filter(isPresent) || [],
    "content.shipName":
      props.filterByShip?.map((s) => s?.name).filter(isPresent) || [],
    countryNames:
      props.filterByCountries
        ?.map((c) => c?.name?.localized)
        .filter(isPresent) || [],
    portNames:
      props.filterByPorts
        ?.map((p) => p?.name?.localized || p?.data?.name?.localized)
        .filter(isPresent) || [],
    features: props.filterByFeatures?.filter(isPresent) || [],
    departureYearMonth: buildDepartureYearsMonths(
      props.filterByDepartureYears,
      props.filterByDepartureYearsAndMonths
    ),
    [`cruiseTagsTree.${language.sanityCode}.level0`]:
      props.filterByCruiseTagCategories
        ?.map((cat) => cat?.title?.localized)
        .filter(isPresent) || [],
    landProgrammes:
      props.filterByLandProgrammes
        ?.map((landProgramme) => landProgramme?.code)
        .filter(isPresent) || []
  };

  const params = qs.stringify({ refinementList });
  return `${props.defaultFYCPath || "#"}?${params}`;
};
